import { useTapTrait } from './useTapTrait.ts';
import type { BannerTraitHookOptions, TapTraitResult } from './useTapTrait.ts';

export const ORG_CONNECTED_APPS_RATE_TRAIT = 'confluence_smartlink_connector_adoption_by_app';

export function parseOrgConnectedAppsRates(
	raw: string | undefined,
): Record<string, number> | undefined {
	if (raw === undefined || raw.trim() === '') {
		return undefined;
	}

	const rates = raw.split(',').reduce<Record<string, number>>((acc, segment) => {
		const colonIdx = segment.indexOf(':');
		if (colonIdx === -1) return acc;
		const provider = segment.slice(0, colonIdx).trim();
		const percentRaw = segment.slice(colonIdx + 1).trim();
		if (!provider || percentRaw === '') return acc;
		const percent = Number(percentRaw);
		if (Number.isNaN(percent)) return acc;
		acc[provider] = percent;
		return acc;
	}, {});

	return Object.keys(rates).length > 0 ? rates : undefined;
}

export type OrgConnectedAppsRates = Record<string, number>;

export type UseOrgConnectedAppsRatesResult = TapTraitResult<OrgConnectedAppsRates>;

export function useOrgConnectedAppsRates({
	skip,
}: BannerTraitHookOptions = {}): UseOrgConnectedAppsRatesResult {
	return useTapTrait(ORG_CONNECTED_APPS_RATE_TRAIT, parseOrgConnectedAppsRates, { skip });
}
